import MultiSelectPage from "@components/MultiSelectPage"

const OPTIONS = [
  "intrinsicWillpower",
  "structureAndPlanning",
  "healthyHabits",
  "goodSupportSystem",
  "iDontKnow",
] as const

export default function KeyToSuccess() {
  return <MultiSelectPage translationKey="keyToSuccess" options={OPTIONS} />
}
